/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./bootstrap");

import Vue from "vue";
window.Vue = Vue;

import { debounce } from "lodash";
window.debounce = debounce;

import { createInertiaApp } from "@inertiajs/inertia-vue";
import { Link as InertiaLink } from "@inertiajs/inertia-vue";
Vue.config.devtools = true;
Vue.prototype.$bus = new Vue();
Vue.prototype.$cropOptions = require("./cropOptions");
Vue.prototype.$route = route;

/**
 * autoload components
 *
 * resources/js/components/Jetstream/Welcome => JetstreamWelcome
 */
const files = require.context("./components/", true, /\.vue$/i);
files.keys().map(function (file) {
  let componentName = file.replace(/(\.vue$|\.|\/)/g, "");
  Vue.component(componentName, files(file).default);
});

Vue.component("inertia-link", InertiaLink);

import {
  trans,
  setLocale,
  getLocale,
  transChoice,
  MaticeLocalizationConfig,
  locales,
} from "matice";
window.__ = function (key, options) {
  let ret;
  try {
    ret = trans(key, options);
  } catch (e) {
    // console.log(e);
  }
  return ret || key;
};
Vue.mixin({
  methods: {
    trans: trans,
    __: window.__,
    transChoice: transChoice,
  },
  props: {
    locale: {
      type: String,
      default: () => window.locale,
    },
  },
});

import iframeResize from "iframe-resizer/js/iframeResizer";
Vue.directive("resize", {
  bind: function (el, { value = {} }, vnode) {
    value["onClose"] = function (id) {
      vnode.context.$emit("close");
    };
    el.addEventListener("load", () => iframeResize(value, el));
  },
  unbind: function (el) {
    el.iFrameResizer.removeListeners();
  },
});

import iframeContentWindowResize from "iframe-resizer/js/iframeResizer.contentWindow";
window.isDynamicIframe = false;
window.addEventListener("message", (event) => {
  if (
    event.data &&
    typeof event.data === "string" &&
    event.data.indexOf("[iFrameResizerChild]") == 0
  ) {
    if (!window.isDynamicIframe) {
      window.isDynamicIframe = true;
      // Vue.$bus.$emit('is-dynamic-iframe');
    }
  }
});

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";

/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import { faEuroSign } from "@fortawesome/sharp-solid-svg-icons";
import { faWheat } from "@fortawesome/pro-light-svg-icons";
import { faMessages } from "@fortawesome/pro-regular-svg-icons";
import { faHandshake } from "@fortawesome/pro-regular-svg-icons";
import { faMagnifyingGlass } from "@fortawesome/sharp-solid-svg-icons";
import { faChartLineUp } from "@fortawesome/pro-regular-svg-icons";
import { faFileCertificate } from "@fortawesome/pro-regular-svg-icons";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { faHourglass } from "@fortawesome/sharp-solid-svg-icons";
import { faCircleX } from "@fortawesome/sharp-solid-svg-icons";
import { faTrash } from "@fortawesome/sharp-solid-svg-icons";
import { faFloppyDisk, faListCheck } from "@fortawesome/sharp-solid-svg-icons";
import { faFileSignature } from "@fortawesome/pro-solid-svg-icons";

/* add icons to the library */
library.add(
  faEuroSign,
  faWheat,
  faMessages,
  faHandshake,
  faMagnifyingGlass,
  faChartLineUp,
  faFileCertificate,
  faSpinner,
  faArrowRight,
  faHourglass,
  faCircleX,
  faTrash,
  faFloppyDisk,
  faListCheck,
  faFileSignature
);

/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

createInertiaApp({
  resolve: (name) => require(`./views/${name}`),
  setup({ el, App, props }) {
    const v = new Vue({
      render: (h) => h(App, props),
    });
    return v.$mount(el);
  },
});

/**
 * Helper CSS variable to get viewport height of iOS devices with changing dimensions
 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 * Do not forget CSS part, such as "height: --vh"
 */

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty("--vh", `${vh}px`);

// We listen to the resize event
window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});
